import { useParams } from "react-router-dom";
import { PageContainer } from "../../../App/Components/PageContainer/PageContainer";
import { IconButton, Paper, Tooltip } from "@mui/material";
import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { useGetUserQuery } from "../AbacAppQueries";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlags } from "../../../App/Typings/FeatureFlags";
import UserDetailsForm from "./Components/UserDetailsForm";
import { ManageAccounts } from "@mui/icons-material";
import { useState } from "react";

export default function ManageUserPage() {
  const { id } = useParams<{ id: string }>();
  const { data: currentUser, isLoading } = useGetUserQuery(id);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Initialize EnableABACApplicationManagement LD flag
  // TODO: Remove with ABAC-32
  const { enableAbacApplicationManagement } = useFlags<FeatureFlags>();

  if (!enableAbacApplicationManagement) {
    return null;
  }

  if (isLoading) {
    return (
      <PageContainer>
        <p>Loading...</p>
      </PageContainer>
    );
  }

  if (!isLoading && currentUser) {
    const manageUserBreadcrumbs = [
      {
        breadCrumbName: "Users",
        route: `abacUsers`,
      },
    ];

    return (
      <>
        <PageContainer>
          <Breadcrumb
            pageTitle={currentUser.firstName + " " + currentUser.lastName}
            customBreadcrumbs={manageUserBreadcrumbs}
          />
          <h1 className="page-title">
            Manage {currentUser.firstName + " " + currentUser.lastName}
            <Tooltip title={"Admin Actions"}>
              <IconButton
                sx={{
                  ml: "2%",
                  border: "2px solid rgba(0,0,0,0.3)",
                }}
                onClick={handleClick}
              >
                <ManageAccounts />
              </IconButton>
            </Tooltip>
          </h1>
          <Paper sx={{ mt: 4, p: { xs: 2, lg: 4 } }}>
            <UserDetailsForm
              currentUser={currentUser}
              menuAnchorElement={anchorEl}
              isMenuOpen={open}
              handleMenuClose={handleClose}
            />
          </Paper>
        </PageContainer>
      </>
    );
  }
}
